/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconPlayerRecordFilled = createSolidComponent(
  "player-record-filled",
  "IconPlayerRecordFilled",
  [
    [
      "path",
      {
        d: "M8 5.072a8 8 0 1 1 -3.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 3.995 -6.643z",
        "stroke-width": "0",
        fill: "currentColor"
      }
    ]
  ]
);

export { IconPlayerRecordFilled as default };
//# sourceMappingURL=IconPlayerRecordFilled.js.map
